













































import { Component, Vue } from 'vue-property-decorator'
import ProConfig from '@/config/config'
import FuncUtils from '@/common/utils/FuncUtils'
import JavaHttp from '@/common/network/JavaHttp'
import * as echarts from 'echarts'

@Component({
  name: 'defaultHome',
  components: {}
})
export default class DefaultHome extends Vue {
  public tableData: any[] = []
  mounted() {
    this.getList()
  }
  public queryDate = ''

  getAllListParams() {
    const params: any = {
      page: 1,
      pageSize: 10,
      orderByColumn: 'addTime',
      isAsc: 'desc'
    }
    return params
  }
  // 获取数据
  getList() {
    this.initEchart()
    // JavaHttp.postData('/examine/enter', this.getAllListParams()).then(
    //   (res: any) => {
    //     this.tableData = []
    //     if (res.code == 200) {
    //       this.tableData = res.rows
    //     } else {
    //       // FuncUtils.hitMessageInfo(res.message)
    //     }
    //   }
    // )
  }
  // 改变日期数据
  pickDate(date: string[]) {
    console.log(date)
    const obj = {
      xData: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
      data1: [120, 132, 101, 134, 90, 230, 210, 250, 145, 258, 211, 123],
      data2: [220, 182, 191, 234, 290, 330, 310, 120, 132, 101, 134, 90],
      data3: [150, 232, 201, 154, 190, 330, 410, 90, 230, 210, 250, 145]
    }
    this.initEchart(obj)
  }
  // 绘制图表
  initEchart(obj: any = {}) {
    const keys = Object.keys(obj)
    if (keys.length === 0) {
      console.log('没有数据')
      obj.xData = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
      obj.data1 = [0]
      obj.data2 = [0]
      obj.data3 = [0]
    }
    const myChart = echarts.init(document.getElementById('main'))
    myChart.setOption({
      legend: {
        data: ['总商户数', '总业务办理数', '5元会员总数'],
        left: 0
      },
      tooltip: {
        trigger: 'axis'
      },
      grid: {
        left: '20',
        right: '20',
        bottom: '0%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: obj.xData
      },
      yAxis: {
        type: 'value'
      },
      series: [
        {
          name: '总商户数',
          type: 'line',
          stack: 'Total',
          data: obj.data1
        },
        {
          name: '总业务办理数',
          type: 'line',
          stack: 'Total',
          data: obj.data2
        },
        {
          name: '5元会员总数',
          type: 'line',
          stack: 'Total',
          data: obj.data3,
          itemStyle: {
            normal: {
              color: '#4f5d77',
              lineStyle: {
                color: '#4f5d77'
              }
            }
          }
        }
      ]
    })
    window.addEventListener('resize', () => {
      myChart.resize()
    })
  }
}
